import TinyOSS from 'pano-tiny-oss';
import { toPercent } from 'pano-utils';
import type { MatrixCheckResult, MTaskRespItem } from '@types';
import { sendError } from '@components/Noti';
import { $libUploadingMatrix } from '../../stores/libUploading';
import { taskStartApi } from './taskApis';
import domain from '../../domain';

const ossKey = (path: string, materialId: number) => {
  return `${path.replace(/^\//, '')}/${materialId}_all.jpg`;
};

interface Params {
  taskResp: MTaskRespItem;
  taskItem: MatrixCheckResult;
  onProgress: (progress: string) => void;
}

const matrixUpload = domain.effect(
  async ({ taskResp, taskItem, onProgress }: Params) => {
    const client = new TinyOSS({
      accessKeyId: taskResp.accessKeyId,
      accessKeySecret: taskResp.accessKeySecret,
      stsToken: taskResp.securityToken,
      bucket: taskResp.bucketName,
      endpoint: taskResp.endpointO,
      secure: true,
    });
    const key = ossKey(taskResp.path, taskResp.materialId);
    await client.put(key, taskItem.file, {
      onprogress: (e: ProgressEvent) => {
        const progress = toPercent(e.loaded / e.total);
        onProgress(progress);
      },
      headers: { 'x-oss-storage-class': 'IA' },
    });

    await taskStartApi(taskResp.taskId);
  }
);

matrixUpload.fail.watch(({ params, error }) => {
  $libUploadingMatrix.api.remove(params.taskItem.id);
  sendError(error.message);
});

export default matrixUpload;
